import React from "react";
import { Route, Switch } from "react-router-dom";
import RouteList from "Routes/private/list";
import FourOFour from "Pages/private/404";
import PrivateRoute from "./route";

const routes = [];
const flattenRoutes = (routePath, list) => {
  list.map((item) => {
    let path = routePath + item.path;

    if (item.children?.length > 0 && !item.layout) {
      flattenRoutes(path, item.children);
    }

    routes.push({ ...item, path: path });
  });
};

flattenRoutes("", RouteList);

export default function PrivateRoutes() {
  return (
    <Switch>
      {routes.map((route) =>
        route.component ? (
          <PrivateRoute
            key={route.name}
            path={route.path}
            exact={!route.layout}
            component={route.component}
            authSubject={route.authSubject}
          />
        ) : null
      )}
      <Route path="*" component={FourOFour} />
    </Switch>
  );
}
